import styled from "styled-components";
import {colors, devices, sizes} from "../../utils/styled/_variables.styled";

const SeparatorContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: ${sizes.desktop - 1}px;
  display: flex;
  align-items: center;
  height: ${props => props.separatorHeightDesktop ? props.separatorHeightDesktop+'px' : '15px'};

  @media ${devices.tabletLarge} {
    height: ${props => props.separatorHeightTablet ? props.separatorHeightTablet+'px' : '15px'};
  }

  @media ${devices.mobile} {
    height: ${props => props.separatorHeightMobile ? props.separatorHeightMobile+'px' : '15px'};
  }

  .separator__bar {
    height: 1px;
    width: 100%;
    border: none;
    opacity: ${props => props.hideLine ? `0` : `1`};
    background-color: ${colors.gray2};
  }
`;
export { SeparatorContainer };
